// MenuItem.ts

export default class MenuItem {
    reference_name          : string; //will be merged with menu. for json translation. Es. menu.home
    icon                    : string;
    link                    : string;

    constructor(dict = null)
    {
      if (dict !== null)
      {
        this.icon                   = dict["icon"]          || null;
        this.link                   = dict["link"]          || null;
        this.reference_name         = dict["reference_name"]          || null;
        
      }
    }

  }
